// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResultRowStyle_container__Neb2W {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid black;
  font-size: 18px;
  padding: 1em;
  width: 32em;
  overflow-wrap: break-word;
}

.ResultRowStyle_container__Neb2W:hover {
  background-color: var(--primaryColor);
  color: white;
}

.ResultRowStyle_container__Neb2W:last-child {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/SearchField/ResultRowStyle.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid black;\n  font-size: 18px;\n  padding: 1em;\n  width: 32em;\n  overflow-wrap: break-word;\n}\n\n.container:hover {\n  background-color: var(--primaryColor);\n  color: white;\n}\n\n.container:last-child {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ResultRowStyle_container__Neb2W`
};
export default ___CSS_LOADER_EXPORT___;
